import type { Command } from '../../types/commands'
import { addSessionFile, getSessionFileContent } from '../sessionFilesystem'
import { highlightSyntax } from '../syntaxHighlighter'
import { getContextDefaults } from '../../utils/contextUtils'

export const echoCommand: Command = {
  name: 'echo',
  description: 'Display text or write to file',
  usage: 'echo <text> [> file.txt] [>> file.txt]',
  category: 'system',
  acceptsFiles: true,
  acceptsDirectories: false,
  execute: (args, context) => {
    if (args.length === 0) {
      return [
        {
          type: 'info',
          content: '',
        },
      ]
    }

    const input = args.join(' ')
    const { currentDirectory, sessionFs } = getContextDefaults(context)

    // Check for redirection operators
    const appendMatch = input.match(/(.+?)\s*>>\s*(.+)/)
    const writeMatch = input.match(/(.+?)\s*>\s*(.+)/)

    if (appendMatch) {
      // Append to file
      const text = appendMatch[1].trim().replace(/^["']|["']$/g, '')
      const filename = appendMatch[2].trim()

      // Get existing content
      const fullPath = currentDirectory === '~' ? filename : `${currentDirectory}/${filename}`
      const existingContent = getSessionFileContent(sessionFs, fullPath) || ''
      const newContent = existingContent ? `${existingContent}\n${text}` : text

      // Write to file
      const newFs = addSessionFile(sessionFs, currentDirectory, filename, newContent)
      context?.setSessionFilesystem(newFs)

      return [
        {
          type: 'success',
          content: `Appended ${text.length} bytes to ${filename}`,
        },
      ]
    } else if (writeMatch) {
      // Write to file (overwrite)
      const text = writeMatch[1].trim().replace(/^["']|["']$/g, '')
      const filename = writeMatch[2].trim()

      // Write to file
      const newFs = addSessionFile(sessionFs, currentDirectory, filename, text)
      context?.setSessionFilesystem(newFs)

      return [
        {
          type: 'success',
          content: `Wrote ${text.length} bytes to ${filename}`,
        },
      ]
    }

    // Just display text (with ANSI color code support)
    const text = input.replace(/^["']|["']$/g, '')
    const highlighted = highlightSyntax(text)

    return [
      {
        type: 'info',
        content: (
          <div dangerouslySetInnerHTML={{ __html: highlighted }} />
        ),
      },
    ]
  },
}
